import type { Bonus, FaqItem, SessionModule } from '../types/content';
export const productName = 'MEGAPACK MAESTRO DE SESIONES';
export const ctaHref = '#oferta';
// URL del checkout. Los botones de compra de la oferta y del cierre disparan InitiateCheckout y redirigen aquí.
export const checkoutUrl = 'https://megapack-maestro-de-sesiones-arg.impultienda.ar/checkout';
export const heroMeta = ['6 módulos especializados', '+400 páginas de material profesional', '100% digital', 'Acceso inmediato'];
export const problems = ['Terminás tu día de consulta y todavía te quedan horas de preparación para las sesiones de mañana.', 'Tenés apuntes, PDFs y notas guardados en mil lugares distintos, pero cuando los necesitás no encontrás nada.', 'Te quedás en blanco sin saber cómo seguir cuando una conversación se estanca en plena sesión.', 'Minutos antes de que llegue tu consultante, todavía estás buscando qué preguntas hacerle.', 'Sentís que siempre terminás haciendo las mismas preguntas, sesión tras sesión.', 'Cada vez que aparece un motivo de consulta frecuente, volvés a armar la estructura desde cero.'];

// Portadas oficiales: se muestran tal cual, sin recortes ni modificaciones.
export const modules: SessionModule[] = [{
  number: '01',
  title: 'Trauma y Estrés Postraumático',
  description: 'Material organizado de consulta para orientar la preparación de sesiones relacionadas con trauma y estrés postraumático.',
  resources: ['Estructuras orientativas de sesión', 'Preguntas terapéuticas', 'Posibles aperturas', 'Intervenciones orientativas', 'Posibles cierres y próximos pasos'],
  tagline: 'Un punto de partida ordenado para temáticas sensibles.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/jUPNGbGuvEPEoHfYgWsVxR/Imagen_de_ChatGPT_27_sept_2026,_01_49_39_p.m..png',
  coverWidth: 1024,
  coverHeight: 1536
}, {
  number: '02',
  title: 'Autoestima y Confianza',
  description: 'Recursos organizados para preparar sesiones relacionadas con autoestima, autoconcepto y desarrollo de la confianza.',
  resources: ['Estructuras orientativas de sesión', 'Preguntas para explorar autopercepción', 'Guías de conversación', 'Intervenciones orientativas', 'Posibles cierres y próximos pasos'],
  tagline: 'Más recursos para explorar lo que la persona piensa y siente sobre sí misma.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/cLvnvuD8Pg6d7gUN6wFyDr/PORTADA_MODULO_2.png',
  coverWidth: 1134,
  coverHeight: 1400
}, {
  number: '03',
  title: 'Desafíos en la Crianza',
  description: 'Material de consulta para preparar sesiones vinculadas con desafíos de crianza, dinámicas familiares y acompañamiento a madres, padres y cuidadores.',
  resources: ['Estructuras orientativas de sesión', 'Preguntas para explorar situaciones familiares', 'Guías de conversación', 'Intervenciones orientativas', 'Posibles cierres y próximos pasos'],
  tagline: 'Un punto de partida para ordenar conversaciones complejas sobre crianza.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/i5v7JoQbqT3FNZKqkM4TBP/Imagen_de_ChatGPT_27_sept_2026,_01_38_39_p.m..png',
  coverWidth: 1080,
  coverHeight: 1440
}, {
  number: '04',
  title: 'Ansiedad',
  description: 'Recursos organizados para consultar y adaptar al preparar sesiones relacionadas con ansiedad.',
  resources: ['Estructuras orientativas de sesión', 'Bancos de preguntas', 'Posibles aperturas', 'Preguntas para profundizar', 'Intervenciones y cierres orientativos'],
  tagline: 'Consultá rápidamente diferentes caminos para abordar la sesión.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/qJjscQf9EkHkxVp5zoEZeb/Imagen_de_ChatGPT_27_sept_2026,_01_40_17_p.m..png',
  coverWidth: 1080,
  coverHeight: 1440
}, {
  number: '05',
  title: 'Depresión',
  description: 'Material profesional de consulta para organizar y preparar sesiones relacionadas con depresión.',
  resources: ['Estructuras orientativas de sesión', 'Preguntas terapéuticas', 'Guías de conversación', 'Intervenciones orientativas', 'Posibles cierres y próximos pasos'],
  tagline: 'Recursos organizados para no tener que empezar cada preparación desde cero.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/vkn7oDfGXQECdfPqjA4cRG/Imagen_de_ChatGPT_27_sept_2026,_01_41_57_p.m..png',
  coverWidth: 1024,
  coverHeight: 1536
}, {
  number: '06',
  title: 'Problemas de Pareja y Relaciones',
  description: 'Material de consulta para preparar sesiones relacionadas con conflictos de pareja, comunicación y relaciones interpersonales.',
  resources: ['Estructuras orientativas de sesión', 'Preguntas para explorar conflictos', 'Guías de conversación', 'Intervenciones orientativas', 'Posibles cierres y próximos pasos'],
  tagline: 'Más puntos de partida para abordar conversaciones y dinámicas relacionales.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/rWTjDLNL2CtXsXwCfCvYza/Imagen_de_ChatGPT_27_sept_2026,_01_43_27_p.m..png',
  coverWidth: 1024,
  coverHeight: 1536
}];
// Páginas interiores reales: se muestran tal cual, sin recortes ni modificaciones.
export const insidePages = [{
  src: 'https://cdn.magicpatterns.com/uploads/gBzWfiDYNbZUm6PJJAfhuX/Tomo_1_Trauma_pagina_6.png',
  alt: 'Página interior del Módulo 01 — Trauma y Estrés Postraumático'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aRMKCFuD6S1XWunQujJVFW/Tomo_2_Autoestima_Confianza_pagina_17.png',
  alt: 'Página interior del Módulo 02'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/s5gtFehreyRjeFnEnZebH2/Tomo_3_Desafios_Crianza_pagina_18.png',
  alt: 'Página interior del Módulo 03 — Desafíos en la Crianza'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/f2z4Bht3KwzG6tjMKmCAGg/Tomo_5_Depresion_pagina_11.png',
  alt: 'Página interior del Módulo 05 — Depresión'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/i6AkKP6bgkAmVdYGfpSUTk/Tomo_6_Pareja_Relaciones_pagina_13.png',
  alt: 'Página interior del Módulo 06 — Problemas de Pareja y Relaciones'
}];
export const includedItems = ['Módulo 01 — Trauma y Estrés Postraumático', 'Módulo 02 — Autoestima y Confianza', 'Módulo 03 — Desafíos en la Crianza', 'Módulo 04 — Ansiedad', 'Módulo 05 — Depresión', 'Módulo 06 — Problemas de Pareja y Relaciones', '+400 páginas de material profesional', 'Bono #1 — Kit Primera Sesión', 'Bono #2 — Banco Maestro de Preguntas Terapéuticas', 'Bono #3 — SOS: Sesiones Difíciles', 'Bono #4 — Pack de Hojas de Trabajo para Sesiones', 'Bono #5 — Planificador Express de Sesiones', 'Pago único', 'Acceso de por vida'];

// Portadas oficiales de los bonos: se muestran tal cual, sin recortes ni modificaciones.
export const bonuses: Bonus[] = [{
  label: 'BONO #1',
  name: 'Kit Primera Sesión',
  description: 'Estructura práctica para preparar y conducir una primera sesión con mayor claridad: apertura, encuadre, motivo de consulta, expectativas, objetivos, antecedentes relevantes, recursos, red de apoyo, preguntas iniciales, situaciones frecuentes y formas de organizar el cierre.',
  value: 'USD 27',
  coverImage: 'https://cdn.magicpatterns.com/uploads/wShKQD4P74NuwN7Cv6JqTT/Imagen_de_ChatGPT_27_sept_2026,_02_33_47_p.m..png',
  coverWidth: 1048,
  coverHeight: 1488
}, {
  label: 'BONO #2',
  name: 'Banco Maestro de Preguntas Terapéuticas',
  description: 'Banco organizado de preguntas para abrir conversaciones, explorar emociones y pensamientos, profundizar, identificar patrones y trabajar diferentes áreas como autoestima, relaciones, límites, ansiedad, decisiones, recursos, motivación, avances y cierre de sesión.',
  value: 'USD 47',
  coverImage: 'https://cdn.magicpatterns.com/uploads/tLSZKkobKjcKEyCUCM5y8M/Imagen_de_ChatGPT_27_sept_2026,_02_36_22_p.m..png',
  coverWidth: 1134,
  coverHeight: 1400
}, {
  label: 'BONO #3',
  name: 'SOS: Sesiones Difíciles',
  description: 'Recursos de consulta para esos momentos en los que una sesión se bloquea o se vuelve difícil: silencios, “no sé”, llanto, enojo, resistencia, respuestas breves, cambios constantes de tema, falta de temas, estancamiento, pedidos de consejo directo y otras situaciones frecuentes.',
  value: 'USD 26',
  coverImage: 'https://cdn.magicpatterns.com/uploads/nVaaiq6dYpTGVvbKtzKexe/Imagen_de_ChatGPT_27_sept_2026,_07_54_20_p.m..png',
  coverWidth: 1024,
  coverHeight: 1536
}, {
  label: 'BONO #4',
  name: 'Pack de Hojas de Trabajo para Sesiones',
  description: 'Hojas imprimibles de apoyo para trabajar emociones, pensamientos, desencadenantes, necesidades, límites, relaciones, recursos, fortalezas, toma de decisiones, estrés, regulación, valores, avances y seguimiento.',
  value: 'USD 15',
  coverImage: 'https://cdn.magicpatterns.com/uploads/bAEhePAPabWFEbUuJsd4RC/Imagen_de_ChatGPT_27_sept_2026,_07_54_26_p.m..png',
  coverWidth: 1134,
  coverHeight: 1400
}, {
  label: 'BONO #5',
  name: 'Planificador Express de Sesiones',
  description: 'Sistema de planificación rápida para organizar antes, durante y después de cada sesión: foco, temas pendientes, preguntas posibles, recursos, observaciones, avances y próximos pasos.',
  value: 'USD 27',
  coverImage: 'https://cdn.magicpatterns.com/uploads/xzxdNDnrKp1HTBmqYYJbtE/Imagen_de_ChatGPT_27_sept_2026,_07_54_31_p.m..png',
  coverWidth: 1048,
  coverHeight: 1488
}];
export const pricing = {
  bonusTotal: '$90.970',
  today: '$16.990'
};

// Duración del contador del banner superior (en horas), contada desde la primera visita de cada usuario.
export const offerCountdownHours = 24;
export const trustItems = ['Pago seguro', 'Acceso inmediato', 'Garantía de 7 días'];
export const guarantee = {
  days: '7',
  text: 'Accedé a Maestro de Sesiones y revisá el material con tranquilidad. Si dentro de los primeros 7 días considerás que el producto no es lo que esperabas, podés solicitar el reembolso de acuerdo con nuestra política de devolución.',
  highlight: 'Tenés 7 días para conocer el material y decidir.'
};

// IMPORTANTE: testimonios y nombres PLACEHOLDER FICTICIOS, solo para visualizar la landing.
// Reemplazar por testimonios reales (con autorización) antes de publicar.
export const testimonials = [{
  quote: 'Antes perdía muchísimo tiempo buscando preguntas y organizando cada sesión. Ahora tengo todo ordenado por temática y encuentro en minutos un punto de partida para preparar lo que necesito.',
  name: 'Lic. Mariana R.',
  role: 'Psicóloga Clínica'
}, {
  quote: 'Los bancos de preguntas son de lo que más uso. Cuando quiero explorar un tema desde otro ángulo, abro el módulo correspondiente y encuentro nuevas preguntas y estructuras que puedo adaptar a la sesión.',
  name: 'Lic. Valentina M.',
  role: 'Psicóloga'
}, {
  quote: 'Me sorprendió la cantidad y la organización del material. No son recursos sueltos: está estructurado de una forma que hace muy fácil consultar lo que necesitás y adaptarlo a tu manera de trabajar.',
  name: 'Lic. Marcelo P.',
  role: 'Psicólogo Clínico'
}];
export const faqs: FaqItem[] = [{
  question: '¿Cómo recibo el material?',
  answer: 'Después de confirmar el pago, obtenés acceso digital al material.'
}, {
  question: '¿Es un producto físico?',
  answer: 'No. MEGAPACK MAESTRO DE SESIONES es un producto 100% digital.'
}, {
  question: '¿Cuánto tiempo tengo acceso?',
  answer: 'Acceso de por vida.'
}, {
  question: '¿Puedo imprimir los materiales?',
  answer: 'Los archivos se entregan en PDF y pueden consultarse digitalmente o imprimirse para uso personal/profesional según las condiciones de licencia.'
}, {
  question: '¿El material reemplaza mi formación o criterio profesional?',
  answer: 'No. Los recursos están diseñados como material educativo y de apoyo para profesionales. Deben adaptarse al contexto, necesidades del consultante, formación, criterio profesional y normativa aplicable.'
}, {
  question: '¿Sirve para profesionales que recién comienzan?',
  answer: 'El material está diseñado para facilitar la organización y consulta de recursos, pero no reemplaza formación, supervisión ni habilitación profesional.'
}];
export const disclaimer = 'MEGAPACK MAESTRO DE SESIONES es un recurso educativo y de apoyo profesional. No sustituye formación académica, supervisión clínica, evaluación individual, diagnóstico, tratamiento, criterio profesional ni protocolos de emergencia. Cada profesional es responsable de evaluar la pertinencia de los recursos según cada caso, su formación, alcance profesional y normativa aplicable.';
export const footerLinks = ['Términos y Condiciones', 'Política de Privacidad', 'Política de Reembolso', 'Contacto / Soporte'];